import { Link } from 'react-router'
import { Container } from '@/components/common'
import { ROUTES } from '@/constants/routes'
import { quickLinks } from '@/data/not-found-content'
import { BotanicalAccent } from './BotanicalAccent'

export const NotFoundContent = () => (
  <section className="min-h-[calc(100vh-72px)] bg-base-50 flex items-center">
    <Container>
      <div className="max-w-2xl mx-auto text-center">
        {/* Decorative botanical */}
        <div className="flex justify-center mb-8 animate-fade-in">
          <BotanicalAccent />
        </div>

        {/* Gold divider */}
        <div className="w-10 h-[2px] bg-gold-400 rounded-full mx-auto mb-6 animate-fade-in" />

        {/* Heading */}
        <h1 className="font-display text-4xl sm:text-5xl text-base-900 leading-tight mb-5 animate-fade-in-up">
          This path leads
          <br />
          <span className="text-green-700">nowhere</span>
        </h1>

        {/* Body */}
        <p
          className="text-base-500 text-[0.95rem] leading-relaxed max-w-sm mx-auto mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.08s' }}
        >
          The page you're looking for has moved or doesn't exist. Let us guide you back to what you
          need.
        </p>

        {/* Primary CTA */}
        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-12 animate-fade-in-up"
          style={{ animationDelay: '0.14s' }}
        >
          <Link
            to={ROUTES.HOME}
            className="inline-flex min-h-12 items-center gap-3 rounded-full bg-green-700 px-7 text-sm font-medium text-white transition-colors hover:bg-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4"
          >
            <svg className="w-4 h-4" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path
                fillRule="evenodd"
                d="M9.293 2.293a1 1 0 011.414 0l7 7A1 1 0 0117 11h-1v6a1 1 0 01-1 1h-2a1 1 0 01-1-1v-3a1 1 0 00-1-1H9a1 1 0 00-1 1v3a1 1 0 01-1 1H5a1 1 0 01-1-1v-6H3a1 1 0 01-.707-1.707l7-7z"
                clipRule="evenodd"
              />
            </svg>
            Back to Home
          </Link>
          <Link
            to={ROUTES.CONTACT}
            className="inline-flex min-h-12 items-center rounded-full border border-green-300 px-7 text-sm font-medium text-green-700 transition-colors hover:border-green-400 hover:bg-green-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700 focus-visible:ring-offset-4"
          >
            Contact Us
          </Link>
        </div>

        {/* Quick links */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <p className="text-[0.65rem] tracking-[0.18em] uppercase text-base-400 font-medium mb-4">
            Or go directly to
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2">
            {quickLinks.map((l) => (
              <Link
                key={l.path}
                to={l.path}
                className="px-4 py-2 rounded-full border border-base-200 text-sm text-base-600 hover:border-gold-400 hover:text-base-900 hover:bg-base-100 transition-all"
              >
                {l.label}
              </Link>
            ))}
          </div>
        </div>

        {/* Red accent — one deliberate use */}
        <div
          className="mt-14 flex items-center justify-center gap-3 animate-fade-in"
          style={{ animationDelay: '0.26s' }}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-red-600 opacity-50" aria-hidden="true" />
          <p className="text-[0.65rem] text-base-400 tracking-widest uppercase">
            Instrumental Health · Medical Herbalism
          </p>
          <span className="w-1.5 h-1.5 rounded-full bg-red-600 opacity-50" aria-hidden="true" />
        </div>
      </div>
    </Container>
  </section>
)
